import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import FacturasConciliarHeader from './FacturasConciliarHeader';
import FacturasConciliarFiltros from './FacturasConciliarFiltros';
import FacturasConciliarLista from './FacturasConciliarLista';

const PanelFacturasConciliar = ({
    rfcSeleccionado,
    cargandoFacturas,
    facturasFiltradas,
    facturasSeleccionadas,
    setFacturasSeleccionadas,
    totalFacturasSeleccionadas,
    toggleSeleccionFactura,
    fechaInicialFacturas,
    setFechaInicialFacturas,
    fechaFinalFacturas,
    setFechaFinalFacturas,
    tipoDocumento,
    setTipoDocumento,
    montoMinimo,
    setMontoMinimo,
    montoMaximo,
    setMontoMaximo,
    movimientosSeleccionados,
    onConciliar,
    cargandoConciliacion
}) => {
    return (
        <Card className="shadow-sm h-100">
            <Card.Header className="bg-gradient-info">
                <FacturasConciliarHeader 
                    facturasFiltradas={facturasFiltradas}
                    facturasSeleccionadas={facturasSeleccionadas}
                    setFacturasSeleccionadas={setFacturasSeleccionadas}
                    totalFacturasSeleccionadas={totalFacturasSeleccionadas}
                    movimientosSeleccionados={movimientosSeleccionados}
                    onConciliar={onConciliar}
                    cargandoConciliacion={cargandoConciliacion}
                />
            </Card.Header>

            <FacturasConciliarFiltros 
                rfcSeleccionado={rfcSeleccionado}
                fechaInicialFacturas={fechaInicialFacturas}
                setFechaInicialFacturas={setFechaInicialFacturas}
                fechaFinalFacturas={fechaFinalFacturas}
                setFechaFinalFacturas={setFechaFinalFacturas}
                tipoDocumento={tipoDocumento}
                setTipoDocumento={setTipoDocumento}
                montoMinimo={montoMinimo}
                setMontoMinimo={setMontoMinimo}
                montoMaximo={montoMaximo}
                setMontoMaximo={setMontoMaximo}
            />

            <Card.Body className="p-3">
                <FacturasConciliarLista 
                    rfcSeleccionado={rfcSeleccionado}
                    cargandoFacturas={cargandoFacturas}
                    facturasFiltradas={facturasFiltradas}
                    facturasSeleccionadas={facturasSeleccionadas}
                    toggleSeleccionFactura={toggleSeleccionFactura}
                />
            </Card.Body>
        </Card>
    );
};



PanelFacturasConciliar.propTypes = {
    rfcSeleccionado: PropTypes.string,
    cargandoFacturas: PropTypes.bool,
    facturasFiltradas: PropTypes.array,
    facturasSeleccionadas: PropTypes.array,
    setFacturasSeleccionadas: PropTypes.func,
    totalFacturasSeleccionadas: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    toggleSeleccionFactura: PropTypes.func,
    fechaInicialFacturas: PropTypes.instanceOf(Date),
    setFechaInicialFacturas: PropTypes.func,
    fechaFinalFacturas: PropTypes.instanceOf(Date),
    setFechaFinalFacturas: PropTypes.func,
    tipoDocumento: PropTypes.string,
    setTipoDocumento: PropTypes.func,
    montoMinimo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    setMontoMinimo: PropTypes.func,
    montoMaximo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    setMontoMaximo: PropTypes.func,
    movimientosSeleccionados: PropTypes.array,
    onConciliar: PropTypes.func,
    cargandoConciliacion: PropTypes.bool
};

export default PanelFacturasConciliar;
